import { useQuery } from "@tanstack/react-query";
import useAPI from "../../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../../api/hooks/useIsIntegrated";
import { jiraIssuesKeys, jiraKeys } from "../../../../../api/queryKeys";

export const useJiraQueries = (selectedProject) => {
  const {
    fetchProjects,
    fetchJiraDefaultIssueConfig,
    fetchJiraIssueTypes,
    fetchJiraUsers,
    fetchJSMReporterOptions,
    checkJSMIsAgent,
    fetchJiraLabels,
  } = useAPI();

  const { isIntegrated, isIntegratedLoading } = useIsIntegrated("jira");

  // Project options
  const { data: projectOptions, isSuccess: projectOptionsIsSuccess } = useQuery(
    {
      queryKey: jiraKeys.jiraProjects(),
      queryFn: fetchProjects,
      select: (response) => response.data,

      enabled: isIntegrated && !isIntegratedLoading,
    }
  );

  // Default issue config
  const { data: defaultIssueConfig, isSuccess: defaultIssueConfigLIsSuccess } =
    useQuery({
      queryKey: jiraIssuesKeys.jiraDefaultIssueConfig,
      queryFn: fetchJiraDefaultIssueConfig,

      enabled: isIntegrated && !isIntegratedLoading,
    });

  // Issue types
  const { data: issueTypes, isSuccess: issueTypesIsSuccess } = useQuery({
    queryKey: jiraKeys.jiraIssueTypes(selectedProject?.key),
    queryFn: () => fetchJiraIssueTypes(selectedProject.key),
    select: (response) => response.data,

    enabled: !!selectedProject && isIntegrated && !isIntegratedLoading,
  });

  // Assignee options
  const { data: assigneeOptions, isSuccess: assigneeOptionsIsSuccess } =
    useQuery({
      queryKey: jiraKeys.jiraUsers(selectedProject?.key),
      queryFn: () => fetchJiraUsers(selectedProject?.key),
      select: (response) => response.data,

      enabled: !!selectedProject && isIntegrated && !isIntegratedLoading,
    });

  // Reporter options
  const { data: reporterOptions, isSuccess: reporterOptionsIsSuccess } =
    useQuery({
      queryKey: jiraKeys.jiraReporterOptions(),
      queryFn: () => fetchJSMReporterOptions(),
      select: (response) => response.data,

      enabled: isIntegrated && !isIntegratedLoading,
    });

  // Labels
  const { data: labelOptions } = useQuery({
    queryKey: jiraKeys.jiraLabels(),
    queryFn: fetchJiraLabels,
    select: (response) => response.data?.values,

    enabled: isIntegrated && !isIntegratedLoading,
  });

  // JSM Agent Permissions
  const { data: jsmIsAgent, isSuccess: jsmIsAgentIsSuccess } = useQuery({
    queryKey: jiraKeys.jsmIsAgent(),
    queryFn: checkJSMIsAgent,
    select: (response) => response.data,

    enabled: isIntegrated && !isIntegratedLoading,
  });

  return {
    // Integration status
    isIntegrated,
    isIntegratedLoading,

    // Projects data
    projectOptions,
    projectOptionsIsSuccess,

    // Default issue config
    defaultIssueConfig,
    defaultIssueConfigLIsSuccess,

    // Issue types data
    issueTypes,
    issueTypesIsSuccess,

    // Assignee data
    assigneeOptions,
    assigneeOptionsIsSuccess,

    // Reporter options
    reporterOptions,
    reporterOptionsIsSuccess,

    // Labels data
    labelOptions,

    // JSM Agent Permissions
    jsmIsAgent,
    jsmIsAgentIsSuccess,
  };
};
